import { useCallback } from 'react';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

import { useChangePassword } from 'api';
//import { useAuth } from 'common/auth';

import ChangePassword from '../components/ChangePassword';
import { UserPayload } from 'api/profile';

// type Props = {
//   isLoading: boolean;
//   onSubmit: () => Promise<void>;
// };

const ChangePasswordContainer = () => {
  const { t } = useTranslation();

  //const { userId = '' } = useAuth();

  const { changePassword } = useChangePassword();

  const handleSubmit = useCallback(
    async (payload: UserPayload) => {
      await changePassword(payload);
      message.success(t('changePassword.success'));
    },
    [changePassword, t]
  );

  return <ChangePassword onSubmit={handleSubmit} />;
};

export default ChangePasswordContainer;
